// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import './styles/index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// eslint-disable-next-line node/no-missing-import
import IconSettings from '@salesforce/design-system-react/components/icon-settings';

import { App } from './containers';
import configureStore from './store/configure';
// eslint-disable-next-line node/no-missing-import
import IntlApp from './containers/IntlApp';

const store = configureStore();

const render = function () {
	ReactDOM.render(
		<Provider store={store}>
			<IconSettings iconPath="/assets/icons">
				<IntlApp>
					<Router>
						<Switch>
							<Route path="/" exact component={App} />
						</Switch>
					</Router>
				</IntlApp>
			</IconSettings>
		</Provider>,
		document.getElementById('mount') // eslint-disable-line no-undef
	);
};

render();
